import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Logger, getDescription } from '../../../common/public-api';
import { TOAST_WIDGET_KEY } from '../../public-api';
import {
  ApiError,
  DEFINED_BUSINESS_ERROR_CODE_TYPE,
  ErrorService,
  ErrorType,
} from '../../services/error/public-api';
import { LoaderService } from '../loader/loader.service';
import { ToastService } from '../toast/toast.service';

/**
 * UI widget page
 *
 * @export
 * @class WidgetComponent
 */
@Component({
  selector: 'sigv-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css'],
})
export class WidgetComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();
  toastWidgetKey = TOAST_WIDGET_KEY;
  isShowLoader = false;

  constructor(
    private _toastService: ToastService,
    private _errorService: ErrorService,
    private _loaderService: LoaderService,
    private _logger: Logger,
    @Inject(DEFINED_BUSINESS_ERROR_CODE_TYPE) private _definedErrorCodeType: any
  ) {}

  //#region Angular lifecycle hooks
  ngOnInit(): void {
    // Subscribe to do some UI actions while getting error from error service.
    this._errorService
      .getErrorSubject()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (event) => {
          switch (event.type) {
            case ErrorType.ApiError:
              break;
            case ErrorType.BusinessError:
              const error = event.error as ApiError;
              // Find matched error code from defined error code class and get corresponding error message.
              const mappedValue = Object.getOwnPropertyNames(
                this._definedErrorCodeType
              ).find(
                (x) => this._definedErrorCodeType[x] === error.errorCode
              ) as string;
              const msg = getDescription(
                this._definedErrorCodeType,
                mappedValue
              );
              this._toastService.error(msg);
              break;
            case ErrorType.UnknownError:
              this._toastService.error('Library.Common.UnknownError');
              break;
            case ErrorType.UnAuthorizedError:
            default:
              break;
          }
        },
      });

    /**
     * Subscribe to display or hide UI loader while getting loader visibility changed notification
     * from loader service.
     */
    this._loaderService
      .getSideMenuObservable()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (isDisplay) => {
          this._logger.debug(
            `[${this.constructor.name}] => Change loader visibility:`,
            isDisplay
          );
          this.isShowLoader = isDisplay;
        },
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
  //#endregion
}
